import { ElementNotFound } from "@senciamatch/frontend/components/ElementNotFound";
import { LoadingData } from "@senciamatch/frontend/components/LoadingData";
import { useDebounce } from "@senciamatch/frontend/hooks/useDebounce";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StaffTable } from "./table";

export const StaffsPage: React.FC = () => {
  const [search, setSearch] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebounce(search, 500);
  const navigate = useNavigate();

  const getStaffs = trpc.getStaffsSearch.useQuery({ search: debouncedSearch, page, limit: 20, isActive });

  if (getStaffs.isPending) return <LoadingData />;
  if (!getStaffs.data) return <ElementNotFound />;

  return (
    <div className="h-screen flex flex-col">
      <h2 className="text-2xl font-bold py-10 flex-shrink-0">従業員一覧</h2>
      <div className="overflow-x-auto py-10 bg-white border border-base-100 px-8 flex-grow flex flex-col">
        <div className="flex justify-between pb-8 flex-shrink-0">
          <div className="flex flex-row gap-8 items-center w-4/5">
            <div className="relative w-1/2">
              <input
                type="text"
                className="w-full border border-gray-200 rounded-md px-4 py-2"
                placeholder="スタッフ名 / カナ で検索"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
              {getStaffs.isFetching && (
                <div className="absolute right-2 top-1/2 -translate-y-1/2">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900" />
                </div>
              )}
            </div>
            <label className="label cursor-pointer flex items-center gap-2">
              <input
                type="checkbox"
                className="checkbox checkbox-sm"
                checked={isActive}
                onChange={() => {
                  setIsActive(!isActive);
                  setPage(1);
                }}
              />
              <span className="label-text">在籍のみ表示</span>
            </label>
          </div>
          <button
            type="button"
            className="bg-primary-700 text-white px-4 py-2 rounded-md"
            onClick={() => navigate("/staffs/new")}
          >
            新規登録
          </button>
        </div>
        <StaffTable staffs={getStaffs.data.staffs ?? []} mutate={getStaffs.refetch} />
        <div className="flex justify-center mt-4 flex-row gap-8">
          <button
            type="button"
            className="join-item btn"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            «
          </button>
          <div className="flex flex-row gap-2 items-center">
            <span className="text-sm font-bold">{page}</span>
            <span className="text-sm">/</span>
            <span className="text-sm font-bold">{getStaffs.data.totalPages}</span>
          </div>

          <button
            type="button"
            className="join-item btn"
            onClick={() => setPage((p) => Math.min(getStaffs.data.totalPages, p + 1))}
            disabled={page === getStaffs.data.totalPages}
          >
            »
          </button>
        </div>
      </div>
    </div>
  );
};
